import * as Sentry from '@sentry/react';

export const initSentry = () => {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    allowUrls: [`${window.location.origin}/assets/`],
    ignoreErrors: ['Error invoking postEvent', 'window.webkit.messageHandlers'],
  });
};
